import { render, staticRenderFns } from "./crm-setting-form.vue?vue&type=template&id=c8134c24"
import script from "./crm-setting-form.vue?vue&type=script&lang=js"
export * from "./crm-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports